import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SurveyService } from '../../../core/services/survey/survey.service';
@Component({
  selector: 'app-goals-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './goals-form.component.html',
  styleUrl: './goals-form.component.scss',
})
export class GoalsFormComponent {
  @Input() formGroup: FormGroup;
  @Output() nextStepEvent = new EventEmitter<void>();

  constructor(private surveyService: SurveyService) {}

  private _goalQuestions = [
    {
      id: 'healthyEating',
      text: 'Sağlıklı yemek',
      controlName: 'healthyEatingGoal',
    },
    {
      id: 'medicationUsage',
      text: 'Düzenli ilaç kullanımı',
      controlName: 'medicationUsageGoal',
    },
    {
      id: 'checkups',
      text: 'Muayene ve kontroller',
      controlName: 'checkupsGoal',
    },
    {
      id: 'exercise',
      text: 'Düzenli egzersiz',
      controlName: 'exerciseGoal',
    },
    {
      id: 'saltUsage',
      text: 'Düşük tuz/sodyum kullanımı',
      controlName: 'saltUsageGoal',
    },
    {
      id: 'stressReduction',
      text: 'Stres azaltma',
      controlName: 'stressReductionGoal',
    },
  ];

  get goalQuestions() {
    return this._goalQuestions;
  }

  priorityLevels = [
    { id: 'veryHigh', text: 'Çok öncelikli', value: 3 },
    { id: 'high', text: 'Öncelikli', value: 2 },
    { id: 'medium', text: 'İkinci planda', value: 1 },
    { id: 'low', text: 'Önemsiz', value: 0 },
  ];

  ngOnInit(): void {
    this.getPreparationPageSurveys();
  }

  getPreparationPageSurveys() {
    this.surveyService.getPreparationPageSurveys().subscribe(() => {});
  }

  goToNextStep(): void {
    if (this.formGroup.invalid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }
    this.nextStepEvent.emit();
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.get(controlName);
    return control
      ? control.invalid && (control.dirty || control.touched)
      : false;
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
    });
  }
}
